import React from 'react';
import { TimerResult } from 'react-timer-hook';
import './Timer.scss';

type CountdownTimerProps = {
    timer: TimerResult;
}

function padLeadingZero(value: number): string {
    if (value == null) return "00";
    if (value.toString().length === 1) return '0' + value.toString();
    return value.toString();
}

const CountdownTimer: React.FC<CountdownTimerProps> = (props: CountdownTimerProps) => {

    return props.timer && (
        <span className="text-end">
            <span className="timer-bg">{padLeadingZero(props.timer.minutes)}</span><strong>:</strong><span className="timer-bg">{padLeadingZero(props.timer.seconds)}</span>
        </span>
    );
}

export default CountdownTimer;